const tokenKey = 'access_token'

export function getToken() {
  // return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI1ZWYxZTlhZjY1YTBkNzQ0NDM5NDk1NTEiLCJpYXQiOjE1OTcxMTcxNDZ9.nekKeooAMgs58QOd-GKqEuhtNcYyOa5H1BVo6K6AtaU'
  return localStorage.getItem(tokenKey)
}

export function setToken(token) {
  return localStorage.setItem(tokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(tokenKey)
}
